<span [ngClass]="cssClasses">{{ task.clientVisible ? 'Visible' : 'Hidden' }}</span>
